import { useState } from "react";
import type { ImgHTMLAttributes } from "react";

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & { priority?: boolean };

function Image({ priority: _priority, ...props }: ImageProps) {
  return <img {...props} />;
}

export function Faq() {
  const [openFaqs, setOpenFaqs] = useState<number[]>([]);

  const toggleFaq = (index: number) => {
    setOpenFaqs((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const faqs = [
    {
      question: "What exactly do I get for $99?",
      answer:
        "A fully responsive, professional single-page website with mobile-optimized design, a contact form or CTA button, basic on-page SEO, hosting on Netlify, and one round of minor revisions. As of June 2026, Swift MVP has shipped 100+ live sites with an average delivery time of under 24 hours and a 5/5 client rating.",
      sources: [
        { label: "Netlify hosting", href: "https://www.netlify.com" },
      ],
    },
    {
      question: "How can you deliver so fast?",
      answer:
        "Swift MVP uses a sprint workflow with pre-built production components. Across 100+ delivered projects, the average build time is roughly 19 hours - a fraction of the typical multi-week agency timeline. Payments are processed instantly through Stripe so work can start the same day.",
      sources: [
        { label: "Stripe checkout", href: "https://stripe.com" },
      ],
    },
    {
      question: "What if I'm not satisfied?",
      answer:
        "One revision round is included with every package. If Swift MVP misses the agreed scope or quality bar, it is corrected before handoff. A 100% money-back guarantee applies and refund requests are resolved within 48 hours.",
      sources: [],
    },
    {
      question: "Do I own my website and code?",
      answer:
        "Yes. After delivery and payment, you receive the full source code and assets, free of license restrictions. Hosting on Netlify can be transferred to your own account at any time.",
      sources: [],
    },
    {
      question: "What happens after delivery?",
      answer:
        "You receive a production-ready handoff, deployment guidance, and a checklist of next steps. Every site is built on a standard React and Vite stack so any developer can extend it later.",
      sources: [
        { label: "React", href: "https://react.dev" },
        { label: "Vite", href: "https://vitejs.dev" },
      ],
    },
  ];

  return (
    <section className="backk relative overflow-hidden bg-background px-[30px] pb-[74px] sm:pb-[120px] pt-[18px] sm:pt-[100px] md:px-12 lg:px-[60px]">
      <div className="mx-auto flex w-full max-w-6xl flex-col md:flex-row items-center justify-center gap-[clamp(50px,5vw,74px)]">
        <div className="flex w-full max-w-[306px] sm:max-w-[354px] flex-col items-start gap-[clamp(20px,4vw,40px)]">
          <div
            className="
    flex items-center gap-[6px]
    rounded-[50px]
    border border-[#F3F3F3]
    bg-[#ffffff]
    py-[5px] px-[13px]
    shadow-[
      1px_0px_2px_0px_rgba(0,0,0,0.03),
      2px_2px_3px_0px_rgba(0,0,0,0.03),
      5px_4px_4px_0px_rgba(0,0,0,0.02),
      9px_8px_5px_0px_rgba(0,0,0,0),
      14px_12px_5px_0px_rgba(0,0,0,0)
    ]
  "
          >
            <span className="font-sans text-[13px] font-normal leading-none tracking-[-0.02em] text-[#000]">
              FAQs
            </span>
            {/* <span className="flex items-center justify-center rounded-[30px] bg-[#f8f9fb] px-[10px] py-[8px] font-sans text-[13px] font-normal leading-none tracking-[-0.02em] text-[#000000]">
              it might help you
            </span> */}
          </div>
          <h2 className="max-w-[500px] text-start font-plus-jakarta-extrabold text-[clamp(40px,4.5vw,60px)] font-bold leading-none tracking-[-0.02em] text-[#000000]">
            Frequently Asked Questions
          </h2>
          <p className="max-w-[440px] text-start font-sans text-[16px] md:text-[15px] font-medium leading-[140%] tracking-[0%] text-[#716C77]">
            We Get It-Curiosity Leads to Success! Got questions? That&apos;s a
            great sign. Here are some answers.
          </p>
        </div>
        <div className="w-full max-w-[550px] space-y-[clamp(6px,1vw,12px)]">
          {faqs.map((item, index) => {
            const isOpen = openFaqs.includes(index);
            const closedShadow =
              "-1px 2px 6px 0px #00000005, -6px 9px 11px 0px #00000005, -13px 21px 15px 0px #00000003, -23px 38px 18px 0px #00000000, -36px 59px 19px 0px #00000000";
            const openShadow =
              "-1px 2px 5px 0px #0000000D, -5px 8px 9px 0px #0000000A, -11px 18px 13px 0px #00000008, -20px 32px 15px 0px #00000003, -31px 50px 16px 0px #00000000";
            return (
              <div
                key={item.question}
                className={`group w-full overflow-hidden rounded-[15px] border border-[#E4E2EB] bg-[#ffffff] transition-all duration-150 hover:border-[#ced2d9] hover:shadow-lg hover:scale-[1.01] active:scale-[0.99] p-[5px] cursor-pointer ${isOpen ? "open" : ""}`}
                style={{ boxShadow: isOpen ? openShadow : closedShadow }}
              >
                <div
                  className={`
    flex w-full cursor-pointer list-none select-none
    items-start justify-between
    px-[30px] py-[16.5px]
    bg-[#FAFAFA]
    rounded-[10px]
    transition-all duration-300 ease-in-out
    overflow-hidden
  `}
                  onClick={(event) => {
                    event.preventDefault();
                    toggleFaq(index);
                  }}
                >
                  <div className="flex w-full flex-col text-left">
                    <div className="flex w-full items-start justify-between gap-[clamp(14px,2.6vw,40px)]">
                      <span className="text-[16px] sm:text-[18px] font-medium leading-[1.2] text-[#000000]">
                        {item.question}
                      </span>

      {/* RIGHT ICON */}
      <span className="shrink-0 flex items-center justify-center pt-[2px]">
        {!isOpen ? (
          <Image
            src="/Images/plus.svg"
            alt=""
            width={24}
            height={24}
          />
        ) : (
          <Image
            src="/Images/minus.svg"
            alt=""
            width={24}
            height={24}
          />
        )}
      </span>
    </div>

    {/* ANSWER */}
    <div
      className={`grid transition-all duration-300 ease-in-out ${
        isOpen
          ? "grid-rows-[1fr] opacity-100"
          : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        <p className="pt-[clamp(13px,2vw,25px)] text-[clamp(12px,1.5vw,15px)] font-normal leading-[140%] text-[#716C77]">
          {item.answer}
        </p>
        {item.sources.length > 0 && (
          <p className="pt-[10px] text-[11px] leading-[140%] text-[#9B95B4]">
            Sources:{" "}
            {item.sources.map((source, sourceIndex) => (
              <span key={source.href}>
                <a
                  href={source.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-[#000]"
                >
                  {source.label}
                </a>
                {sourceIndex < item.sources.length - 1 ? ", " : ""}
              </span>
            ))}
          </p>
        )}
      </div>
    </div>
  </div>
</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// export function Faq() {
//   const [activeIndex, setActiveIndex] = useState(0);

//   const faqs = [
//     {
//       id: "01",
//       question: "What exactly do I get for $99?",
//       answer: "You get a fully responsive, professional single-page website. This includes mobile-optimized design, contact form or CTA button, basic SEO setup, hosting on Netlify, and one round of minor revisions. We deliver everything live and ready to use.",
//     },
//     {
//       id: "02",
//       question: "How can you deliver so fast?",
//       answer: "We use a proven sprint workflow and prebuilt production components, so your project gets designed, implemented, and shipped within 24 hours.",
//     },
//     {
//       id: "03",
//       question: "What if I'm not satisfied?",
//       answer: "By missing the agreed scope or quality bar, we make it right before handoff. You get one revision round included.",
//     },
//     {
//       id: "04",
//       question: "Do I own my website/code?",
//       answer: "Yes. After delivery and payment, the full website code and assets are yours.",
//     },
//     {
//       id: "05",
//       question: "What happens after delivery?",
//       answer: "You receive a production-ready handoff, deployment support guidance, and clear next steps for future updates.",
//     },
//   ];

//   return (
//     <section className="backk relative overflow-hidden bg-white py-[60px] sm:py-[100px] px-6 md:px-12 lg:px-[60px]">
//       {/* Grid Background */}
//       <div
//         className="absolute inset-0 z-0 opacity-10 pointer-events-none"
//         style={{
//           backgroundImage: `
//             linear-gradient(#E5E7EB 1px, transparent 1px),
//             linear-gradient(90deg, #E5E7EB 1px, transparent 1px)
//           `,
//           backgroundSize: '80px 80px'
//         }}
//       />
//       <div className="w-full flex justify-center mb-[15px]">
//         <div className="flex items-center gap-[6px] rounded-[50px] border border-[#F3F3F3] bg-[#ffffff] py-[5px] px-[8px] max-w-[175px]">
//             <span className="font-sans text-[13px] font-normal leading-none tracking-[-0.02em] text-[#000]">
//               FAQs
//             </span>
//             <span className="flex items-center justify-center rounded-[30px] bg-[#f8f9fb] px-[10px] py-[8px] font-sans text-[13px] font-normal leading-none tracking-[-0.02em] text-[#000000] whitespace-nowrap">
//               it might help you
//             </span>
//           </div>

//           </div>
//       <div className="relative z-10 max-w-7xl mx-auto flex flex-col items-center">
//         <div className="text-center mb-16 max-w-2xl flex flex-col items-center">
//           <h2 className="text-[clamp(40px,5vw,72px)] font-bold leading-tight tracking-tight text-black mb-6 max-w-[306px] sm:max-w-full">
//             Frequently Asked Questions
//           </h2>
//           <p className="text-[#716C77] text-lg font-medium leading-relaxed max-w-[518px]">
//             We Get It-Curiosity Leads to Success! Got questions? That&apos;s a
//             great sign. Here are some
//           </p>
//         </div>

//         <div className="flex flex-col lg:flex-row gap-4 w-full h-auto lg:h-[650px] items-stretch">
//           {faqs.map((faq, index) => {
//             const isActive = activeIndex === index;
//             return (
//               <div
//                 key={faq.id}
//                 onClick={() => setActiveIndex(index)}
//                 className={`group relative overflow-hidden rounded-[20px] transition-all duration-700 ease-[cubic-bezier(0.4,0,0.2,1)] cursor-pointer border border-[#E4E2EB] p-[5px] flex-1 lg:flex-none
//                   ${isActive
//                     ? 'w-full h-auto lg:h-full lg:w-[312px] bg-white shadow-2xl scale-[1.02] z-20'
//                     : 'w-full h-auto lg:h-full lg:w-[180px] bg-white text-black hover:bg-gray-50 hover:border-gray-300 z-10'
//                   }
//                 `}
//               >
//                 <div className={`relative h-full w-full rounded-[16px] transition-all duration-700 px-[30px] py-[32px] flex flex-col ${isActive ? 'bg-black text-white' : 'bg-[#FAFAFA] text-black'}`}>
//                   {/* Top Label & Icon */}
//                   <div className="flex justify-between items-center mb-[0px] lg:mb-[200px] gap-[21px]">
//                     <span className={`text-sm font-semibold tracking-wider ${isActive ? 'text-[#FFF]' : 'text-[#000000] whitespace-nowrap'}`}>
//                       Question {faq.id}
//                     </span>
//                     <div className={`w-[16px] h-[16px] rounded-full flex items-center justify-center mb-[7px] text-2xl font-light transition-transform duration-500 ${isActive ? 'rotate-180' : 'rotate-0'}`}>
//                       {isActive ? '−' : '+'}
//                     </div>
//                   </div>

//                   {/* Vertical/Horizontal Text for Inactive */}
//                   {!isActive && (
//                     <>
//                       {/* Vertical on Desktop */}
//                       <div className="hidden lg:flex flex-grow items-center justify-center">
//                         <h3 className="text-[20px] xl:text-[24px] font-medium whitespace-nowrap rotate-[-90deg] transform origin-center text-center px-4">
//                           {faq.question}
//                         </h3>
//                       </div>
//                       {/* Horizontal on Mobile */}
//                       <div className="lg:hidden mb-4">
//                          <h3 className="text-[18px] font-medium">
//                           {faq.question}
//                         </h3>
//                       </div>
//                     </>
//                   )}

//                   {/* Content for Active */}
//                   {isActive && (
//                     <div className="flex-grow flex flex-col h-full animate-in fade-in slide-in-from-bottom-2 duration-700">
//                       <div className="flex-grow">
//                         <h3 className="text-[20px] sm:text-[24px] font-medium mb-[24px]">Answer:</h3>
//                         <div className="w-full h-[1px] bg-[#FFFFFF4D] mb-[24px]" />
//                         <p className="text-[#FFF] text-[15px] leading-relaxed max-w-md">
//                           {faq.answer}
//                         </p>
//                       </div>

//                       <div className="mt-8 mb-[20px]">
//                         <div className="bg-[#181818] border border-[#FFFFFF12] rounded-[100px] h-[43px] max-w-[130px] w-full hover:scale-[1.05] active:scale-[0.95] hover:shadow-xl group transition-all duration-300">
//                           <button
//                             className="
//                               bg-[linear-gradient(0deg,_#CECECE_0%,_#FFFFFF_100%)]
//                               h-full
//                               px-[20px]
//                               text-[#000]
//                               font-normal
//                               rounded-[40px]
//                               flex
//                               gap-[10px]
//                               w-full
//                               items-center
//                               justify-center
//                               transition-all
//                               duration-300
//                               hover:brightness-110
//                               cursor-pointer
//                               whitespace-nowrap
//                             "
//                           >
//                             <span className="text-[13px]">More About Us</span>
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// }
